var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21,21.7 16.5,17.2 16.5,7.3 17.5,7.3 17.5,16.8 21.7,21  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 16.5,
    className: "st0",
    width: 1.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 16.5,
    className: "st0",
    width: 1.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 28.6,
    className: "st0",
    width: 1,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 3.5,
    className: "st0",
    width: 1,
    height: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,1.5v1C25,2.5,31.5,9,31.5,17S25,31.5,17,31.5S2.5,25,2.5,17c0-3,0.9-5.9,2.7-8.4l2.1-2.1v4.2h1V4.9H2.5v1 h4L4.4,7.9L4.4,8c-1.9,2.6-2.9,5.7-2.9,9c0,8.5,6.9,15.5,15.5,15.5S32.5,25.5,32.5,17S25.5,1.5,17,1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ae951602413f59066611faa3339dd1aa.svg";
export { ForwardRef as ReactComponent };